// extracted by mini-css-extract-plugin
export default {"textarea":"Contact_textarea__cnahK","completed":"Contact_completed__Mb9t2","form":"Contact_form__fHxoS","formGroup":"Contact_formGroup__e724G"};